import PropTypes from 'prop-types';

export const customToolDataPropTypes = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  info: PropTypes.string,
  subTools: PropTypes.array,
  projectType: PropTypes.string,
  templateType: PropTypes.string,
  templateGroup: PropTypes.string,
  status: PropTypes.string,
  bigImage: PropTypes.string,
  wideImage: PropTypes.string,
});
